export const keys = {
  INDEXES: "indexes",
  INDEX: "index",
  VIDEOS: "videos",
  VIDEO: "video",
  TASK: "task",
  SEARCH: "search",
  AUTHORS: "authors",
} as const;


